import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Page } from "@digital-services/shell";

import OrganizationApplications from "../components/OrganizationApplications";

const ApplicationPage: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "applications" });

  return (
    <Page title={t("page_title")}>
      <OrganizationApplications />
    </Page>
  );
};

export default ApplicationPage;
